import PropTypes from 'prop-types'
import { Card, Inline, Button, Text } from '@leroy-merlin-br/backyard-react-ui'

const Banner = ({ onClick }) => {
  return (
    <Card>
      <Inline justify="between" align="center">
        <div>
          <Text size="kilo" noMargin bold>
            Conta pra gente o que você curte!
          </Text>
          <Text size="kilo" noMargin>
            Assim conseguimos mostrar só vantagens que tem a ver com você. ;)
          </Text>
        </div>

        <Button color="purple" variant="outline" size="kilo" onClick={onClick}>
          Preencher preferências
        </Button>
      </Inline>
    </Card>
  )
}

Banner.propTypes = {
  onClick: PropTypes.func.isRequired
}

export default Banner
